import React, { Component, useState, useEffect } from "react";
import axios from "axios";
import { NotificationManager } from 'react-notifications';
import { Link } from "react-router-dom";
import moment from "moment";
import {Info, Trash2} from "lucide-react";
import SearchUser from "./search/SearchUser";

class Userall extends Component {
    state = {
        modal: false,
        searchResults: [],
        searchMessage: ''
    };

    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
    };

    handleDelete = async (id, name) => {
        try {
            const response = await axios.delete(`users/${id}`);
            if (response.status === 204) {
                NotificationManager.success('Supprimé avec succès', 'Supprimer', 4000);
                this.props.refreshUsers();
            } else {
                NotificationManager.warning('Une erreur est survenue lors de la suppression', 'Erreur', 4000);
            }
        } catch (error) {
            console.error("Error deleting user", error);
        }
    };

    handleSearch = async (e) => {
        try {
            const response = await axios.get(`/usersearch?name=${e.target.value}`);
            if (response.status === 200) {
                this.setState({ searchResults: response.data.search });
            } else {
                this.setState({ searchMessage: response.data.message });
            }
        } catch (error) {
            console.error("Error searching user", error);
        }
    };

    render() {
        const { users } = this.props;
        const { searchResults, searchMessage } = this.state;
        const displayedUsers = searchResults.length > 0 ? searchResults : users;

        return (
            <div className="table-responsive-md">
                <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <label>
                                    Afficher &nbsp;
                                    <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0"
                                        className="form-control form-control-sm">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>&nbsp;éléments
                                </label>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                <label>
                                    Rechercher :
                                    <input
                                        type="search"
                                        className="form-control form-control-sm h31"
                                        placeholder=""
                                        aria-controls="DataTables_Table_0"
                                        onChange={this.handleSearch}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div className="row">
                        {displayedUsers.map(user => (
                            <UserCard key={user.id} user={user} handleDelete={this.handleDelete} />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

const UserCard = ({ user, handleDelete }) => {
    const formattedDate = moment(user.created_at).fromNow();

    return (
        <div className="col-xl-4 col-sm-6">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <div className="flex-1 ms-3">
                            <h6 className="font-size-16 mb-1">
                                <strong>{user.name}</strong> {user.prenom}
                            </h6>
                            <span className={`badge rounded-pill ${user.role === 'Administrateur' ? 'bg-primary' : 'bg-success'}`} style={{ color: "#ffffff" }}>
                                {user.role}
                            </span>
                            <span className="badge rounded-pill bg-light text-dark">{formattedDate}</span>
                        </div>
                    </div>
                    <UserDetails id={user.id} user={user} />
                    <div className="d-flex gap-2 pt-4">
                        <Link to={`/user/${user.id}`}>
                            <button type="button" className="btn btn-outline-info btn-sm mr-2">
                            <Info size={16} strokeWidth={1.25} /> Profile
                            </button>
                        </Link>
                        <button onClick={() => handleDelete(user.id)} className="btn btn-outline-danger btn-sm">
                        <Trash2 size={16} strokeWidth={1.25} /> Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const UserDetails = ({ id, user }) => {
    const [entretien, setEntretien] = useState('');
    const [favori, setFavori] = useState('');

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const response = await axios.get(`users/${id}`);
                if (response.status === 200) {
                    setEntretien(response.data.entretien);
                    setFavori(response.data.favo);
                }
            } catch (error) {
                console.error("Error fetching user details", error);
            }
        };

        if (id) {
            fetchUserDetails();
        }
    }, [id]);

    return (
        <div className="mt-3 pt-1">
            <p className="text-muted mb-0 mt-2"><i className="bi bi-telephone"></i>&nbsp;{user.phone}</p>
            <p className="text-muted mb-0"><i className="bi bi-envelope-at"></i>&nbsp;{user.email}</p>
            <p className="text-muted mb-0"><i className="bi bi-buildings"></i>&nbsp;{user.societe}</p>
            <p className="text-muted mb-0 mt-2"><i className="bi bi-people"></i>&nbsp;Demande d'entretien ({entretien.length})</p>
            <p className="text-muted mb-0 mt-2"><i className="bi bi-star"></i>&nbsp;Liste des favoris ({favori.length})</p>
            <p className="text-muted mb-0 mt-2">
                <span className={`badge ${user.account ? 'badge-warning' : 'badge-info'}`}>
                    <i className={`bi bi-person-fill-${user.account ? 'slash' : 'check'}`}></i>&nbsp;
                    {user.account ? 'Compte Désactivé' : 'Compte Activé'}
                </span>
            </p>
        </div>
    );
};

export default Userall;
